module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_iterators.js
 ** module id = 29
 ** module chunks = 1
 **/